import DashboardDealerInvitedPanel from "./dashboardDealerInvitedPanel.container"

export default DashboardDealerInvitedPanel
